export default __webpack_public_path__ + "static/media/receiver.53464c76.png";